var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTruckWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_360_8478",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_360_8478)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.99976 20.0001C5.16642 20.0001 4.45809 19.7085 3.87476 19.1251C3.29142 18.5418 2.99976 17.8335 2.99976 17.0001H0.999756V6.00012C0.999756 5.45012 1.19559 4.97929 1.58726 4.58762C1.97892 4.19596 2.44976 4.00012 2.99976 4.00012H16.9998V8.00012H19.9998L22.9998 12.0001V17.0001H20.9998C20.9998 17.8335 20.7081 18.5418 20.1248 19.1251C19.5414 19.7085 18.8331 20.0001 17.9998 20.0001C17.1664 20.0001 16.4581 19.7085 15.8748 19.1251C15.2914 18.5418 14.9998 17.8335 14.9998 17.0001H8.99976C8.99976 17.8335 8.70809 18.5418 8.12476 19.1251C7.54142 19.7085 6.83309 20.0001 5.99976 20.0001ZM5.99976 18.0001C6.28309 18.0001 6.52059 17.9043 6.71226 17.7126C6.90392 17.521 6.99976 17.2835 6.99976 17.0001C6.99976 16.7168 6.90392 16.4793 6.71226 16.2876C6.52059 16.096 6.28309 16.0001 5.99976 16.0001C5.71642 16.0001 5.47892 16.096 5.28726 16.2876C5.09559 16.4793 4.99976 16.7168 4.99976 17.0001C4.99976 17.2835 5.09559 17.521 5.28726 17.7126C5.47892 17.9043 5.71642 18.0001 5.99976 18.0001ZM17.9998 18.0001C18.2831 18.0001 18.5206 17.9043 18.7123 17.7126C18.9039 17.521 18.9998 17.2835 18.9998 17.0001C18.9998 16.7168 18.9039 16.4793 18.7123 16.2876C18.5206 16.096 18.2831 16.0001 17.9998 16.0001C17.7164 16.0001 17.4789 16.096 17.2873 16.2876C17.0956 16.4793 16.9998 16.7168 16.9998 17.0001C16.9998 17.2835 17.0956 17.521 17.2873 17.7126C17.4789 17.9043 17.7164 18.0001 17.9998 18.0001ZM16.9998 13.0001H21.2498L18.9998 10.0001H16.9998V13.0001Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTruckWhite);
export default __webpack_public_path__ + "static/media/icon_truck_white.0a0f58792fad9e304adc880d56b6700f.svg";
export { ForwardRef as ReactComponent };